import ChangePassword from './ChangePassword';
import MyProfile from './MyProfile';
import { Tabs } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import './ProfileWorkspace.css';

const Profile: React.FC = () => {
  const items = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined /> Personal profile
        </span>
      ),
      children: <MyProfile />,
    },
    {
      key: '2',
      label: (
        <span>
          <LockOutlined /> Password & security
        </span>
      ),
      children: <ChangePassword />,
    },
  ];

  return (
    <main className="profile-page">
      <header className="profile-page__header">
        <div>
          <span>Account settings</span>
          <h1>Profile</h1>
          <p>
            Manage your recruiter identity, communication preferences, and
            security.
          </p>
        </div>
      </header>
      <Tabs className="profile-page__tabs" defaultActiveKey="1" items={items} />
    </main>
  );
};

export default Profile;
